// extracted by mini-css-extract-plugin
export default {"error":"style_error__BUWRA","not-found":"style_not-found__TAqSU","not-found-header":"style_not-found-header__65tnb"};